import { render, staticRenderFns } from "./college_info.vue?vue&type=template&id=a2bdfd4e&"
import script from "./college_info.vue?vue&type=script&lang=js&"
export * from "./college_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports